import store from '@/store';

const groupClassReportFeatureName = 'reports.live_instruction.group_class';
const privateClassReportFeatureName = 'reports.live_instruction.private_class';

const groupClassReportRoute = {
  path: '/reports/live-instruction/group',
  name: 'reports.live_instruction.group_class',
  component: () =>
    import(
      /* webpackChunkName: 'live-instruction-report' */
      '@/views/live-instruction/components/GroupClassesReport'
    ),
  meta: { isTimeZoneSensitive: true },
};

const privateClassReportRoute = {
  path: '/reports/live-instruction/private',
  name: 'reports.live_instruction.private_class',
  component: () =>
    import(
      /* webpackChunkName: 'live-instruction-report' */
      '@/views/live-instruction/components/PrivateClassesReport'
    ),
  meta: { isTimeZoneSensitive: true },
};

const liveInstructionRoute = {
  path: '/reports/live-instruction',
  name: 'reports.live_instruction',
  component: () =>
    import(
      /* webpackChunkName: 'live-instruction-report' */
      '@/views/live-instruction/LiveInstructionView'
    ),
  redirect: () => {
    const hasAccessTo = store.getters['features/hasAccessTo'];

    if (hasAccessTo(groupClassReportFeatureName)) {
      return { name: groupClassReportRoute.name };
    }

    if (hasAccessTo(privateClassReportFeatureName)) {
      return { name: privateClassReportRoute.name };
    }

    return { name: 'root' };
  },
  children: [
    groupClassReportRoute,
    privateClassReportRoute,
    {
      path: '*',
      redirect: { name: 'reports.live_instruction' },
    },
  ],
};

export default liveInstructionRoute;
